import type { ClickoutUrl } from '@/helpers/clickout-helper';
import {
	getTitlePlayerUrl,
	TitlePlayerQueryParamMapping,
	type TitlePlayerQueryParams,
} from '@/features/title-player/helpers/title-player-url';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';
import { useRouter } from 'vue-router/composables';

export function useTitlePlayerNavigation() {
	const router = useRouter();
	const routingStore = useRoutingStore();

	function clearTitlePlayerQueryParams() {
		const clearedParams = Object.fromEntries(
			Object.keys(TitlePlayerQueryParamMapping).map(key => [key, undefined])
		);
		router.replace({ query: { ...routingStore.activeRoute?.query, ...clearedParams } });
	}

	function openTitlePlayerDetail({
		clickoutUrl,
		fullPath,
		extra,
	}: {
		clickoutUrl: ClickoutUrl;
		fullPath: string;
		extra?: TitlePlayerQueryParams;
	}) {
		const linkContextId = clickoutUrl.contexts?.LinkContext?.link?.self ?? undefined;

		const url = getTitlePlayerUrl({ fullPath, linkContextId, ...extra });

		router.push(url!);
	}

	return { clearTitlePlayerQueryParams, openTitlePlayerDetail };
}
